import { Col, Row } from "components/primitives";
import { FC } from "react";
import styled from "styled-components";

interface Props {
  leadingNumber: number;
  numerator: number;
  denominator: number;
  fontSize?: number;
}

export const NumberLineFraction: FC<Props> = ({
  leadingNumber,
  numerator,
  denominator,
  fontSize = 3,
}) => {
  return (
    <OuterContainer style={{ fontSize: `${fontSize}cqh` }}>
      {(leadingNumber !== 0 || numerator === 0) && <p>{leadingNumber}</p>}
      {numerator !== 0 && denominator !== 0 && (
        <InnerContainer style={{ fontSize: `${fontSize / 1.3}cqh` }}>
          <small>{numerator}</small>
          <FractionLine />
          <small>{denominator}</small>
        </InnerContainer>
      )}
    </OuterContainer>
  );
};

const OuterContainer = styled(Row)`
  align-items: center;
  gap: 3px;
  height: 1.5em;
`;

const InnerContainer = styled(Col)`
  justify-content: center;
  align-items: center;

  small {
    font-weight: 600;
  }
`;

const FractionLine = styled.div`
  height: 1px;
  width: 100%;
  border-bottom: 1px solid currentColor;
`;
